import { ValorCartaCreditoFinanceiro } from './valor-carta-credito.model';
import { Moment } from 'moment';

export class EnvioCartaCreditoFinanceiro {

  id: number;
  valorCartaCredito: ValorCartaCreditoFinanceiro;
  dataSolicitacao: Moment;
  idArquivoCarta: string;
  enviado: boolean;
  dataEnvio: Moment;
  nrRecibo: string;
  idArquivoRecibo: string;

}
